module.exports = __webpack_public_path__ + "static/media/1.5da8e46f.jpeg";